import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: flex;
        border-bottom: 1px solid ${getColor("common.border")} !important;
        padding-bottom: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                `,
                css`
                    flex-direction: column;
                `,
                null,
                null,
                null,
            ])};
    `,
};

customerSelectorToolbarStyles.searchButton = {
    variant: "secondary",
    css: css`
        margin-left: auto;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                    width: 100%;
                `,
                css`
                    margin-top: 10px;
                    width: 100%;
                `,
                null,
                null,
                null,
            ])};
    `,
};
